// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__12tmP","signatureBlock":"Footer_signatureBlock__3rD4Y","signature":"Footer_signature__K_b3s"};